import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Eyebrow from "Root/profile/components/common/Eyebrow";
import H2Font from "Root/profile/components/common/H2Font";
import H3Font from "Root/profile/components/common/H3Font";
import RegFont from "Root/profile/components/common/RegFont";
import styles from "./styles.module.scss";
const advantages = [
    {
        title: "Feel More Supported",
        text: (_jsxs(RegFont, { children: ["By reaching out to their RD, ", _jsx("b", { children: " over 250k+ Gainful community members" }), " say they feel they had someone to\u00A0 guide them through their nutrition journey"] })),
    },
    {
        title: "Improve Overall Health",
        text: (_jsxs(RegFont, { children: ["After one month of checking in with their RD, ", _jsx("b", { children: "88% of customers" }), " say the interaction aided them in their wellness journey"] })),
    },
    {
        title: "Build Consistency",
        text: (_jsxs(RegFont, { children: ["Since starting their Gainful system, \u2154 ", _jsx("b", { children: "customers" }), " who worked with a Gainful Dietitian say they feel more\u00A0 consistent in hitting their goals"] })),
    },
];
const TargetAdvantages = () => (_jsx("div", { className: styles.advantages, children: _jsxs("div", { className: styles.wrapper, children: [_jsx(Eyebrow, { children: "support made simple" }), _jsxs(H2Font, { children: ["Join the\u00A0", _jsx("b", { children: "250k+" }), "\u00A0 Gainful Community Members who say they gained from our Registered Dietitians"] }), _jsx("div", { className: styles.points, children: advantages.map((item) => (_jsxs("div", { className: styles.point, children: [_jsx(H3Font, { children: item.title }), _jsx("p", { children: item.text })] }, item.title))) })] }) }));
export default TargetAdvantages;
